export const TAB_AD = 'ad';
export const TAB_ALL = 'all';
export const TAB_COMMON = 'view';
